import styled from "styled-components";

export const GridItem = styled.div`
  flex: 0 0 calc(33.33% - 20px);
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;
